// extracted by mini-css-extract-plugin
export default {"admitCard":"AdmitChances_admitCard__LVa2Q","dream":"AdmitChances_dream__AnHK3","safe":"AdmitChances_safe__D56pl","target":"AdmitChances_target__0lMYi"};